/*
 * @Author: your name
 * @Date: 2022-01-12 10:45:04
 * @LastEditTime: 2022-01-12 10:45:05
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \gw-react\src\store\action.js
 */
export const GET_EARID = "GET_EARID";
